export default {
  clearRequests (state) {
    state.requests = []
  },
  setRequests (state, requests) {
    if (Array.isArray(state.requests) && state.requests.length > 0) {
      state.requests = [...state.requests, ...requests]
    } else {
      state.requests = requests
    }
  },
  setIsLoading (state, value) {
    state.isLoading = value
  },
  setSelectedRequest (state, request) {
    state.selectedRequest = request
  },
  setSubmitSuccess (state, value) {
    state.submitSuccess = value
  },
  setNextPageKey (state, nextPageKey) {
    state.nextPageKey = nextPageKey
  }
}
